var chunkMapping = {
	"499": [
		499
	],
	"537": [
		6537
	],
	"547": [
		7547
	],
	"565": [
		6565
	],
	"583": [
		9583
	],
	"593": [
		593
	],
	"629": [
		5629
	],
	"725": [
		4725
	],
	"872": [
		1872
	]
};
var idToExternalAndNameMapping = {
	"499": [
		"default",
		"./Patient360App",
		5056
	],
	"593": [
		"default",
		"./ContractsApp",
		5255
	],
	"1872": [
		"default",
		"./QualityApp",
		6953
	],
	"4725": [
		"default",
		"./ClaimsApp",
		9937
	],
	"5629": [
		"default",
		"./TcmApp",
		2822
	],
	"6537": [
		"default",
		"./ReferralsApp",
		2180
	],
	"6565": [
		"default",
		"./SupportCenterApp",
		9863
	],
	"7547": [
		"default",
		"./CareGapsApp",
		795
	],
	"9583": [
		"default",
		"./PopHealthApp",
		4006
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}